import type { IconSvgObject } from './types';

const ElearningExchangeIcon: IconSvgObject = [
  ["path", { d: "M10.5488 2.057C21.8258 1.03997 25.1359 13.9011 18.8569 19.2487M18 17.5V20H21M13.439 21.9554C2.21623 22.8477 -1.14815 10.1113 5.13083 4.76376M6 6.5L6 4H3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 14H9.5C8.67157 14 8 14.6716 8 15.5M16 14V7H10C8.89543 7 8 7.89543 8 9V15.5M16 14V17H9.5C8.67157 17 8 16.3284 8 15.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11 10H13", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export default ElearningExchangeIcon;
